import api from './api'

export default {
    fetchEntryguide(params) {
      return api.get(`entryguide/`, params)
                .then(response => response.data)
    },
    putEntryguide(payload, id) {
      return api.put(`entryguide/${id}/`, payload)
              .then(response => response.data)
  },
    
            }